angular.module('ihestiaSsoBase.baseInfo', [
  'ihestiaSsoBase.constants',
  'ihestiaCommonDirectives.configHelper',
  'ihestiaSsoBase.userModel'
]);
